<template>
  <v-text-field
    :class="`base-input-field pa-0 ${isFocusedClass}`"
    v-bind="$attrs"
    persistent-placeholder
    @update:model-value="propagateInputChange"
    @focus="() => (isFocused = true)"
    @blur="() => (isFocused = false)"
  >
    <template v-for="(_, slot) in $slots as any" #[slot]="slotData">
      <slot :name="slot" v-bind="slotData" />
    </template>
  </v-text-field>
</template>
<script setup lang="ts">
import { VTextField } from 'vuetify/components'
import { computed, ref } from 'vue'

const $slots = defineSlots<Record<string, any>>()

const isFocused = ref(false)
const isFocusedClass = computed(() => {
  if (!isFocused.value) return ''
  return 'focused'
})
const emit = defineEmits(['input'])
const propagateInputChange = (currentValue: string) => emit('input', currentValue)
</script>
